'use client';

import { type ReactNode } from 'react';

import { T } from '@flipster/i18n';
import ChevronRightIcon from '@flipster/react/icon/generated/ChevronRightIcon';
import { css } from '@flipster/styled-system/css';
import { flex, hstack, square, stack, vstack } from '@flipster/styled-system/patterns';

import { securityTips } from '../../constants';
import KeyIcon from './assets/1-key.svg';
import ScamIcon from './assets/2-scam.svg';
import WalletIcon from './assets/3-wallet.svg';
import { ReportBanner } from './report-banner';

const iconMap: Record<string, ReactNode> = {
  'VIP.r260316.How_to_secure_your_assets': <KeyIcon />,
  'VIP.r260316.Cryptocurrency_scams': <ScamIcon />,
  'VIP.r260316.Fake_crypto_wallets': <WalletIcon />,
};

export const SecurityTipsSection = () => {
  return (
    <div className={stack({ gap: 24 })}>
      <p className={css({ textStyle: 'Title/L', color: 'content.default.level-5' })}>
        <T id='VIP.r260316.Security_tips' />
      </p>
      <div className={css({ gap: { base: 12, tablet: 16 }, tabletDown: stack.raw(), tablet: hstack.raw() })}>
        {securityTips.map((tip) => (
          <a
            key={tip.titleKey}
            href={tip.href}
            className={css({
              gap: 16,
              bg: 'background.default.level-1',
              flex: 1,
              cursor: 'pointer',
              transition: 'opacity 200ms',
              _hover: { opacity: 0.8 },
              tabletDown: hstack.raw({ px: 16, py: 12 }),
              tablet: vstack.raw({ p: 24, rounded: 16 }),
            })}
          >
            <div className={square({ size: { base: 48, tablet: 120 } })}>{iconMap[tip.titleKey]}</div>
            <div
              className={flex({
                gap: 4,
                justify: 'center',
                align: 'center',
                textStyle: 'Title/XS',
                color: 'content.default.level-5',
                textAlign: 'center',
                tabletDown: { justifyContent: 'space-between', flex: 1 },
              })}
            >
              <p>
                <T id={tip.titleKey} />
              </p>
              <ChevronRightIcon size={16} />
            </div>
          </a>
        ))}
      </div>
      <ReportBanner />
    </div>
  );
};
